import React from 'react';

export function FullPageLoader() {
  return (
    <div className="fixed inset-0 bg-white z-50 flex flex-col items-center justify-center gap-3">
      <span className="text-2xl font-bold text-primary font-heading">Faristaa</span>
      <div className="w-8 h-8 border-3 border-primary-light border-t-primary rounded-full animate-spin" />
    </div>
  );
}

export function InlineLoader({ text = 'Loading...' }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 gap-3">
      <div className="w-8 h-8 border-2 border-primary-light border-t-primary rounded-full animate-spin" />
      <p className="text-sm text-text-muted">{text}</p>
    </div>
  );
}

export function SkeletonCard() {
  return (
    <div className="card-p space-y-3 animate-pulse">
      <div className="flex gap-3">
        <div className="w-14 h-14 rounded-full bg-gray-200 flex-shrink-0" />
        <div className="flex-1 space-y-2 pt-1">
          <div className="h-4 bg-gray-200 rounded w-3/4" />
          <div className="h-3 bg-gray-200 rounded w-1/2" />
          <div className="h-3 bg-gray-200 rounded w-2/3" />
        </div>
      </div>
    </div>
  );
}

export function SkeletonSlot() {
  return (
    <div className="grid grid-cols-4 gap-2 px-4">
      {Array(8).fill(0).map((_, i) => (
        <div key={i} className="h-14 bg-gray-200 rounded-lg animate-pulse" />
      ))}
    </div>
  );
}
